/**
 *
 * CampaignTemplates/Show/Profiles
 *
 */

import React, { memo } from 'react'

// Components
import Advisor from 'components/CampaignTemplates/Show/Advisor'

function Profiles({ advisor }) {
	return (
		<div className="bg-light">
			<div className={`container${advisor?.profiles?.length > 1 ? '-fluid' : ''}`}>
				<div className="row">
					{advisor?.profiles?.map((profile, index) => (
						<React.Fragment key={profile.id}>
							<div className="col py-5" style={{ minWidth: 300 }}>
								<Advisor profile={profile} company_name={advisor.company_name} />
							</div>
							{index % 2 === 1 && <div className="w-100"></div>}
						</React.Fragment>
					))}
				</div>
			</div>
		</div>
	)
}

Profiles.propTypes = {}

export default memo(Profiles)
